// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-payment-css-HideWhenRoute__base--SX7km{opacity:1}.src-payment-css-HideWhenRoute__hide--szQ1L{opacity:0;position:absolute;top:0;height:0px}`, "",{"version":3,"sources":["webpack://./src/payment/css/HideWhenRoute.scss"],"names":[],"mappings":"AAAA,4CAEC,SAAA,CAGD,4CACC,SAAA,CACA,iBAAA,CACA,KAAA,CACA,UAAA","sourcesContent":[".base {\r\n\t//transition: all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n\topacity: 1;\r\n}\r\n\r\n.hide {\r\n\topacity: 0;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\theight: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `src-payment-css-HideWhenRoute__base--SX7km`,
	"hide": `src-payment-css-HideWhenRoute__hide--szQ1L`
};
export default ___CSS_LOADER_EXPORT___;
